export function createDraftId(projectId, scheduleId) {
    if (!projectId || !scheduleId) return ""
    return `${projectId}~${scheduleId}`
}
